import React from "react";
import { useMemo } from "react";

import glossaryJson from "./Glossary.json";
import { Link, Tooltip } from "@mui/material";
import { Box } from "@mui/material";

type LearnTextEmbedProps = {
  content: string;
  replaceTab?: boolean;
  skipTerms?: string[];
};

function findFirstLocation(text: string, term: string, description: string) {
  const lower_text = text.toLowerCase();
  const lower_term = term.toLowerCase();

  const index = lower_text.indexOf(lower_term);
  if (index < 0) {
    return {
      start: -1,
      term: "",
      description: "",
    };
  }
  return {
    start: index,
    term: term,
    description: description,
  };
}

function LearnTextEmbed(props: LearnTextEmbedProps) {
  const allEmbeds = useMemo(() => {
    const filteredGlossaryJson = glossaryJson.filter(
      (entry) =>
        !props.skipTerms?.map((skip) => skip.toLowerCase()).includes(entry.term.toLowerCase()) && !entry.skip_embed
    );
    const allFirstLocations = filteredGlossaryJson.map((entry) =>
      findFirstLocation(props.content, entry.term, entry.definition)
    );
    const allFirstLocationsFiltered = allFirstLocations.filter((location) => location.start >= 0);
    const allFirstLocationsSorted = allFirstLocationsFiltered.sort((a, b) => a.start - b.start);
    return allFirstLocationsSorted;
  }, [props.content, props.skipTerms]);

  const newContent = useMemo(() => {
    const accumulatedElements = [];
    var unconsumedText = props.content;
    var consumedIndex = 0;
    for (let i = 0; i < allEmbeds.length; i++) {
      const relativeStart = allEmbeds[i].start - consumedIndex;
      if (relativeStart >= 0) {
        if (relativeStart > 0) {
          accumulatedElements.push(
            <Box key={consumedIndex} sx={{ display: "inline" }}>
              {unconsumedText.slice(0, relativeStart)}
            </Box>
          );
        }
        const relativeEnd = relativeStart + allEmbeds[i].term.length;
        accumulatedElements.push(
          <Tooltip
            key={consumedIndex + relativeStart}
            title={allEmbeds[i].description}
            placement="top-start"
            arrow
            enterDelay={200}
            PopperProps={{ style: { zIndex: 100001 } }}
          >
            <Link
              // component="button"
              color="inherit"
              onClick={() => {
                if (props.replaceTab) {
                  window.location.href = "/learn#" + allEmbeds[i].term;
                } else {
                  window.open("/learn#" + allEmbeds[i].term, "_blank");
                }
              }}
              sx={{ textDecorationLine: "underline", textDecorationStyle: "dotted" }}
            >
              {unconsumedText.slice(relativeStart, relativeEnd)}
            </Link>
          </Tooltip>
        );
        unconsumedText = unconsumedText.slice(relativeEnd);
        consumedIndex += relativeEnd;
      }
    }
    if (unconsumedText) {
      accumulatedElements.push(
        <Box key={consumedIndex} sx={{ display: "inline" }}>
          {unconsumedText}
        </Box>
      );
    }
    return accumulatedElements;
  }, [allEmbeds, props.content]);

  return <>{newContent}</>;
}
export default LearnTextEmbed;
